import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VDialog,{staticStyle:{"z-index":"9999"},attrs:{"persistent":"","height":"150","max-width":"370"},on:{"click:outside":_vm.toggleDialog},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c(VCard,{staticClass:"pa-4",on:{"click":_vm.toggleDialog}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t('text_3g7y'))}}),_c('br')])],1)}
var staticRenderFns = []

export { render, staticRenderFns }